import { Link } from "react-router-dom"
import Logo from '../images/Logo.png'
import { FaLinkedin } from "react-icons/fa"
import { FaGithub } from "react-icons/fa"
import { FaPinterest } from "react-icons/fa"
import { FaWhatsapp } from "react-icons/fa"
import {MdAlternateEmail} from "react-icons/md"

const Footer = () => {
  return (
    <footer>
        <div className="container footer_container">
            <article>
                <Link to="/" className="logo">
                    <img src={Logo} alt="Footer Logo" />
                </Link>
                <p>
                    Lorem ipsum dolor sit amet consectetur
                     adipisicing elit. Magnam, cum numquam
                      eos distinctio modi recusandae exercitationem 
                      ipsa repudiandae atque?
                </p>
                <div className="footer_socials">
                    <a href="https://www/linkedIn.com" target="_blank" rel="noreferrer noopener"><FaLinkedin/></a>
                    <a href="https://www.github.com" target="_blank" rel="noreferrer noopener"><FaGithub/></a>
                    <a href="https://www.pinterest.com" target="_blank" rel="noreferrer noopener"><FaPinterest/></a>
                    <a href="www.whatsapp.com" target="_blank" rel="noreferrer noopener"><FaWhatsapp/></a>
                    <a href="mailto:alexladwong@gmail.com" target="_blank" rel="noreferrer noopener"><MdAlternateEmail/></a>
                </div>
            </article>
            <article>
                <h4>Permalinks</h4>
                <Link to="/About">About</Link>
                <Link to="/Galary">Galary</Link>
                <Link to="/Plans">Plans</Link>
                <Link to="/Trainers">Trainers</Link>
                <Link to="/Contacts">Contacts</Link>
            </article>
            <article>
                <h4>Insight</h4>
                <Link to="/About">About</Link>
                <Link to="/challenges">Challenges</Link>
                <Link to="/Plans">Open Case</Link>
                <Link to="/Trainers">Events</Link>
                <Link to="/Contacts">Communities</Link>
                <Link to="/Contacts">FAQs</Link>
            </article>
            <article>
                <h4>Reach Us</h4>
                <Link to="/Contacts">Partnerships</Link>
                <Link to="/Trainers">Supports</Link>
                <Link to="/Contacts">Get Intouch</Link>
            </article>
        </div>
        
        <div className="footer_copyright">
            <small>2025 Mr.Dollars Investment Training School &copy; All Rights Reserved.</small>
        </div>
    </footer>
  )
}

export default Footer